import { default as accessibility } from "./modules/_accessibility.js";
import { default as modals } from "./modules/_modals.js";
import { default as tabs } from "./modules/_tabs.js";
import { default as categoryFilter } from "./modules/_category_filter.js";
import { default as archiveJump } from "./modules/_archive_jump.js";
import { default as scroll } from "./modules/_scroll.js";
import { default as hero } from "./modules/_hero.js";

(function () {
	accessibility.init();
	modals.init();
	tabs.init();
	categoryFilter.init();
	archiveJump.init();
	scroll.init();
	hero.init();
})();
